import styled from 'styled-components';
// components
import Icon from '../../icons';
import TextButton from '../../buttons/Text';
// styles
import { mediaQuery, palette } from '../../styles';

interface Props {
  checked: boolean;
  message: string;
}

/**
 * Bottom Sheet 체크 버튼
 *
 * @example
 * import BottomSheet from 'cds/bottomsheet';
 * import CheckButton from 'cds/bottomsheet/buttons/Check';
 *
 * <BottomSheet>
 *   <CheckButton message="참여인기순" checked />
 *   <CheckButton message="별점높은순" />
 *   <CheckButton message="리뷰많은순" />
 *   <CheckButton message="가격낮은순" />
 *   <CheckButton message="가격높은순" />
 *   <CheckButton message="최신순" />
 * </BottomSheet>
 */
const CheckButton = ({ checked, message, ...props }: Props) => {
  return (
    <Button {...props}>
      <span>{message}</span>
      {checked && <Icon name="ic_check" stroke={palette.grey50} width={16} height={16} />}
    </Button>
  );
};

const Button = styled(TextButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 52px;
  padding: 0 24px;
  border-bottom: 1px solid ${palette.system.BNB};
  background-color: ${palette.system.BNB};
  font-size: 14px;
  border-radius: 0;

  ${mediaQuery.large} {
    border-bottom: 1px solid ${palette.system.grey};
  }
  & > svg {
    flex-shrink: 0;
  }

  & > span {
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${palette.grey50};
  }
`;

export default CheckButton;
